import {
  SET_SIDE_PANEL_SELECTED_EVENT,
  SET_SIDE_PANEL_SHIFT,
  SET_SIDE_PANEL_COVERAGE_GAP,
  SET_SIDE_PANEL_SELECTED_GAP_INDEX,
  SET_SIDE_PANEL_DIM_ENABLED,
  SET_SIDE_PANEL_GAP_DATE_RANGE,
} from 'actions/sidePanel/shifts';
import {
  SIDE_PANEL_CLEAN_UP,
  UPDATE_SIDE_PANEL_PENDING_PROPERTIES,
  ACCEPT_PENDING_SIDE_PANEL_CONTENT,
  REJECT_PENDING_SIDE_PANEL_CONTENT,
} from 'actions/sidePanel';

const defaultState = {
  pendingProps: null,
  selectedEvent: null,
  selectedShift: null,
  gaps: {
    selectedGap: null,
    selectedGapIndex: null,
    dimEnabled: true,
    startDate: null,
    endDate: null,
  },
};

export default function sidePanelShift(state = defaultState, action) {
  switch (action.type) {
    case SIDE_PANEL_CLEAN_UP:
      if (state.selectedEvent?.event) {
        state.selectedEvent.event.setProp('durationEditable', false);
        state.selectedEvent.event.setExtendedProp('eventSelected', false);
      }
      return {
        ...defaultState,
      };
    case UPDATE_SIDE_PANEL_PENDING_PROPERTIES:
      return {
        ...state,
        pendingProps: { ...state.pendingProps },
      };
    case SET_SIDE_PANEL_SHIFT:
      if (state.pendingProps) {
        return {
          ...state,
          pendingProps: {
            ...state.pendingProps,
            selectedShift: action.payload,
          },
        };
      }
      return {
        ...state,
        selectedShift: action.payload,
      };
    case SET_SIDE_PANEL_SELECTED_EVENT:
      if (state.pendingProps) {
        return {
          ...state,
          pendingProps: {
            ...state.pendingProps,
            selectedEvent: action.payload,
          },
        };
      }
      if (!action.payload && state.selectedEvent?.event) {
        state.selectedEvent.event.setProp('durationEditable', false);
        state.selectedEvent.event.setExtendedProp('eventSelected', false);
      }
      return {
        ...state,
        selectedEvent: action.payload,
      };
    case SET_SIDE_PANEL_COVERAGE_GAP:
      return {
        ...state,
        gaps: {
          ...state.gaps,
          selectedGap: action.payload,
        },
      };
    case SET_SIDE_PANEL_SELECTED_GAP_INDEX:
      return {
        ...state,
        gaps: {
          ...state.gaps,
          selectedGapIndex: action.payload,
        },
      };
    case SET_SIDE_PANEL_DIM_ENABLED:
      return {
        ...state,
        gaps: {
          ...state.gaps,
          dimEnabled: action.payload,
        },
      };
    case SET_SIDE_PANEL_GAP_DATE_RANGE: {
      const { startDate, endDate } = action.payload;
      return {
        ...state,
        gaps: {
          ...state.gaps,
          startDate,
          endDate,
        },
      };
    }
    case ACCEPT_PENDING_SIDE_PANEL_CONTENT:
      return {
        ...state,
        ...state.pendingProps,
        pendingProps: null,
      };
    case REJECT_PENDING_SIDE_PANEL_CONTENT:
      if (state.selectedEvent?.event) {
        state.selectedEvent.event.setProp('durationEditable', true);
        state.selectedEvent.event.setExtendedProp('eventSelected', true);
      }
      return {
        ...state,
        pendingProps: null,
      };
    default:
      return state;
  }
}
